import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/calendar.svg';

export const IconCalendar: IconComponent = props => <Icon {...props} src={src} />;
